enum ImportStatus {
  QUEUED = "queued",
  COMPLETED = "completed",
  ERRORED = "errored",
  RUNNING = "running",
}

export default ImportStatus;
